import { FC } from 'react';
import { Controller } from 'react-hook-form';

import { AboutFormControlProps } from '../../types';
import { CollapseCheckbox } from '../components/collapseCheckbox';
import { KjelVannbarenVarme, kjelVannbarenVarmeDefaultValue } from '../components/kjelVannbarenVarme';
import { useAboutFormContext } from '../../utils';

export const OljeKjel: FC<AboutFormControlProps> = ({ control }) => {
  const { setValue, trigger } = useAboutFormContext();
  return (
    <Controller
      name="oppvarming.oppvarmingOlje.kjel.selected"
      control={control}
      render={({ field, fieldState }) => (
        <CollapseCheckbox
          labelKey="register.tekniskUtstyr.oljeKjel.label"
          error={!!fieldState.error}
          checked={!!field.value}
          onChange={(checked) => {
            field.onChange(checked);

            const newValue = checked ? kjelVannbarenVarmeDefaultValue : undefined;

            setValue('oppvarming.oppvarmingOlje.kjel.value', newValue);
            trigger('oppvarmingSelection.oppvarmingOlje');
          }}
        >
          <KjelVannbarenVarme name="oppvarming.oppvarmingOlje.kjel.value" control={control} />
        </CollapseCheckbox>
      )}
    />
  ); // Placeholder for the component implementation
};
